import { useCallback } from "react";

function canUseGlass() {
  if (typeof window === "undefined") return true;
  return !window.matchMedia("(pointer: coarse)").matches;
}

/** Per-card glass highlight — local cursor only, smooth CSS vars. */
export default function LiquidGlassCard({
  as: Tag = "div",
  className = "",
  children,
  onMouseMove,
  onMouseLeave,
  ...props
}) {
  const handleMove = useCallback(
    (e) => {
      if (!canUseGlass()) return;
      const el = e.currentTarget;
      const rect = el.getBoundingClientRect();
      el.style.setProperty("--lg-x", `${((e.clientX - rect.left) / rect.width) * 100}%`);
      el.style.setProperty("--lg-y", `${((e.clientY - rect.top) / rect.height) * 100}%`);
      onMouseMove?.(e);
    },
    [onMouseMove]
  );

  const handleLeave = useCallback(
    (e) => {
      e.currentTarget.style.setProperty("--lg-x", "50%");
      e.currentTarget.style.setProperty("--lg-y", "50%");
      onMouseLeave?.(e);
    },
    [onMouseLeave]
  );

  return (
    <Tag
      className={`liquid-glass-card ${className}`.trim()}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      {...props}
    >
      {children}
    </Tag>
  );
}
